module.exports = __webpack_public_path__ + "static/media/1.b1a149ca.jpg";